// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2LRho","header_button__delete":"styles_header_button__delete__YMrSS","header_button__edit":"styles_header_button__edit__37B0O"};